/**
 * Generated from com.dataiku.dip.eda.worksheets.models.BinningMode
 */
export enum BinningMode {
    AUTO = 'AUTO',
    FIXED_NB = 'FIXED_NB',
    FIXED_SIZE = 'FIXED_SIZE',
    CUSTOM = 'CUSTOM'
}